import api from './api';

/**
 * @param {string} levelId
 * @param {string} skillId
 * @param {string} testId
 * @returns {Promise<{
 *  test_id: string
 *  is_published: boolean
 *  test_name: string
 *  qpv_reference: string
 *  disable_qpv_ref: boolean
 *  tasks: {
 *      task_id: string
 *      order: number
 *      description: string
 *  }[]
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tests-getOneTest
 */
export default async function getTestComponent(levelId, skillId, testId) {
    const { data } = await api.get(`/levels/${levelId}/skills/${skillId}/tests/${testId}`);

    return data;
}